/**
 * Форматирует диапазон времени фразы транскрипта.
 *
 * Возвращает строку вида `M:SS - M:SS` для диапазонов короче часа
 * и `H:MM:SS - H:MM:SS` начиная с часа. Минуты/часы выводятся без
 * лидирующего нуля; секунды — всегда с нулём.
 *
 * Если `finishedAt` не задан, возвращается одиночный таймстемп начала.
 */
export const formatPhraseTimeRange = (startedAt: number, finishedAt?: number | null): string => {
  const startSec = Math.max(0, Math.floor(startedAt));
  const finishSec = finishedAt != null && finishedAt >= startedAt ? Math.floor(finishedAt) : null;
  const showHours = startSec >= 3600 || (finishSec ?? 0) >= 3600;

  if (finishSec == null) {
    return formatTimestamp(startSec, showHours);
  }
  return `${formatTimestamp(startSec, showHours)} - ${formatTimestamp(finishSec, showHours)}`;
};

const pad = (value: number): string => value.toString().padStart(2, '0');

const formatTimestamp = (totalSeconds: number, showHours: boolean): string => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (showHours) {
    return `${hours}:${pad(minutes)}:${pad(seconds)}`;
  }
  return `${minutes}:${pad(seconds)}`;
};
